/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Beweegthema_Hangendzwaaien3Inputs */

const nl_enums_beweegthema_hangendzwaaien3 = /** @type {(inputs: Enums_Beweegthema_Hangendzwaaien3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hangend zwaaien`)
};

/**

* @param {Enums_Beweegthema_Hangendzwaaien3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_beweegthema_hangendzwaaien3 = /** @type {((inputs?: Enums_Beweegthema_Hangendzwaaien3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Beweegthema_Hangendzwaaien3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_beweegthema_hangendzwaaien3(inputs)
});
export { enums_beweegthema_hangendzwaaien3 as "enums.Beweegthema.HangendZwaaien" }